export default __webpack_public_path__ + "static/media/pride-logo.d20d7ce7.png";